import { createAction, props } from '@ngrx/store';
import { User } from '@app/core/models';

export const getUser = createAction('[User] Get User');

export const getUserSuccess = createAction(
  '[User] Get User Success',
  props<{ user: User.User }>(),
);

export const getUserFailure = createAction(
  '[User] Get User Failure',
  props<{ message: string | undefined }>(),
);

export const getNotificationPreferences = createAction(
  '[User] Get Notification Preferences',
);

export const getNotificationPreferencesSuccess = createAction(
  '[User] Get Notification Preferences Success',
  props<{ preferences: User.NotificationPreferences }>(),
);

export const getNotificationPreferencesFailure = createAction(
  '[User] Get Notification Preferences Failure',
  props<{ message: string | undefined }>(),
);

export const updateNotificationPreference = createAction(
  '[User] Update Notification Preference',
  props<{ preference: Partial<User.NotificationPreferences> }>(),
);

export const updateNotificationPreferenceSuccess = createAction(
  '[User] Update Notification Preference Success',
  props<{ preference: Partial<User.NotificationPreferences> }>(),
);

export const updateNotificationPreferenceFailure = createAction(
  '[User] Update Notification Preference Failure',
  props<{ message: string | undefined }>(),
);
